import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import {  defaultOptionalFee, defaultOptionalFeeState } from "./default";
import { CLEAR_OPTIONAL_FEE_TYPE, FETCH_OPTIONAL_FEE_FAILED, FETCH_OPTIONAL_FEE_PROGRESS, FETCH_OPTIONAL_FEE_SUCCESS } from "./optionalAction";
import { OptionalFeeActions } from ".";




export const optionalFeeReducer = (
state: IStoreState["optionalFee"] = defaultOptionalFeeState,
action: OptionalFeeActions
) => {
    switch (action.type) {
        case FETCH_OPTIONAL_FEE_PROGRESS: {
             const newState = produce(state, (draftState) => {
               draftState.single.loading = LoadState.InProgress;
               draftState.list.data = [];
               draftState.single.data = defaultOptionalFee;
             });
             return newState;
           }
           case FETCH_OPTIONAL_FEE_SUCCESS: {
             const { data } = action.payload;
             const newState = produce(state, (draftState) => {
               draftState.single.loading = LoadState.Loaded;
               draftState.list.data = data;
              
             });
             return newState;
           }
           case FETCH_OPTIONAL_FEE_FAILED: {
             const newState = produce(state, (draftState) => {
               draftState.single.loading = LoadState.Failed;
               draftState.list.data = [];
             });
             return newState;
           }
           case CLEAR_OPTIONAL_FEE_TYPE: {
            return defaultOptionalFeeState;
           }
          
           default: {
            return state;
          }
      }
}